<template>
  <div>
    <LazyHydrate when-idle>
      <NonBrowserOverlay />
    </LazyHydrate>

    <!-- Promo Header Banner Centralized -->
    <PromoHeaderBanner :banners="banners" :default-banners="defaultBanners" />

    <!-- Article pages keep only the site header (through the search bar); the rest of the
         page (article, offer, rail, related, footer) is provided by ArticlePage.vue. The
         A-Z filter + search + breadcrumb bar is rendered here (like every other layout) so
         it looks identical to the rest of the site. -->
    <Header :is-home-page="isHomepage" :timestamp="timestamp" />
    <LazyHydrate v-if="statusCode === 200" when-idle>
      <HeaderBottom />
    </LazyHydrate>
    <section v-if="statusCode === 200" class="content content--articles">
      <main id="main" role="main" class="content--full">
        <nuxt keep-alive :keep-alive-props="{ max: 10 }" />
      </main>
    </section>
    <section v-else-if="statusCode === 404">
      <Error404 />
    </section>
    <section v-else-if="statusCode === 500">
      <Error500 />
    </section>
    <client-only>
      <HelpWidget v-if="$config.HelpWidgetEnabled === true" />
    </client-only>
    <LazyHydrate when-idle>
      <Basket :show-basket="showBasket" :cart="getBasket" />
    </LazyHydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'
import { mapGetters } from 'vuex'

export default {
  components: {
    LazyHydrate,
    Header: () => import('~/components/Header.vue'),
    HeaderBottom: () => import('~/components/HeaderBottom.vue'),
    NonBrowserOverlay: () => import('~/components/NonBrowserOverlay.vue'),
    Basket: () => import('~/components/common/Basket.vue'),
    Error404: () => import('~/components/error/404.vue'),
    Error500: () => import('~/components/error/500.vue'),
    HelpWidget: () => import('~/components/HelpWidget.vue'),
    PromoHeaderBanner: () => import('~/components/PromoHeaderBanner.vue')
  },
  data() {
    return {
      isHomepage: this.$route.path === '/',
      isFromMobile: this.$ua.isFromIphone() || this.$ua.isFromAndroidMobile(),
      isFromTablet: this.$ua.isFromTablet(),
      showBasket: false,
      timestamp: this.$store.getters['utility/timestamp']
    }
  },
  computed: {
    getBasket() {
      return this.$store.getters['basket/payload']
    },
    ...mapGetters({
      statusCode: 'UI/statusCode',
      banners: 'utility/SCOPED_RAW_promoheaderbanners',
      defaultBanners: 'utility/DEAFULT_RAW_promoheaderbanners'
    })
  },
  created() {
    this.$nuxt.$on('SHOW_BASKET', value => {
      if (this.showBasket !== value) {
        this.showBasket = value
      }
    })
  },
  beforeDestroy() {
    // $off method will turned off the event listner
    this.$nuxt.$off('SHOW_BASKET')
  }
}
</script>

<style lang="scss" scoped>
.content--articles {
  display: block;

  .content--full {
    width: 100%;
    max-width: 100%;
  }
}
</style>
